import React from 'react';
import Button from 'commonComponents/Button/Button';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import styles from './OurEmployees.module.scss';

const OurEmployees = ({ header, subheader, title, text, button, photo }) => {
  const headerProps = {
    header,
    subheader,
    anchor: 'our-employees'
  };

  return ( 
    <section className={ styles.OurEmployees }>
      <div className={ styles.content }>
        <PrimarySectionHeader { ...headerProps } />
        <div className={ styles.text }>
          <figure>
            <img src={ photo } />
          </figure>
          <article>
            <h5>{ title }</h5>
            <p>{ text }</p>
            <Button link="/jobs" label={ button } />
          </article>
        </div>
      </div>
    </section>
  );
};
 
export default OurEmployees;
